import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueCookies from 'vue3-cookies'

const app = createApp(App);
app.use(store)
.use(router)
.use(ElementPlus)
.use(VueAxios, axios)
.use(VueCookies)
.component(VueQrcode.name, VueQrcode);
app.mount('#app');
